/* BLOCK INFORMATIONS WITH POPUP */

const informationsWithPopup = document.querySelector('.informations-with-popup');

if(informationsWithPopup) {
    const moreInformationsButton = informationsWithPopup.querySelector('.informations-with-popup__button');
    const informationsWithPopupModal = document.querySelector('.informations-with-popup__modal');
    const informationsWithPopupModalCloseButton = informationsWithPopupModal.querySelector('.informations-with-popup__modal__close-button');

    moreInformationsButton.addEventListener('click', () => {
        informationsWithPopupModal.setAttribute('open', '');
    });

    informationsWithPopupModalCloseButton.addEventListener('click', () => {
        informationsWithPopupModal.removeAttribute('open');
    });
}